import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { Spacer } from '@components/Spacer';
import { Button } from '@components/Button';
import { LevelIndicator, Title } from '@insights_module/components/GarmRiskBadge';
import { GarmOverviewDescription } from '@insights_module/components/show_details_screen/GarmOverviewDescription';
import { GarmFilter, GarmRiskLevelType } from '@insights_module/types/BrandSafety';
import { useShowDetailsContext } from '@insights_module/context/ShowDetailsContext';

const ItemContainer = tw.div`relative px-2 py-1 border-none border-sec-4 rounded`;
const Flex = tw.div`flex items-center justify-start h-full`;
const ItemHeader = tw(Flex)`justify-between cursor-pointer mb-2`;
const CloseButton = tw(Button)`bg-sec-4 text-[9px] text-text-and-icon px-2 py-1 rounded ml-12`;
const CollapsibleContainer = tw.div`transition-all duration-200 overflow-hidden`;

const GarmOverviewListItem = ({
  isSelected,
  garm: { category, risk },
  onClick,
}: {
  isSelected: boolean;
  garm: GarmFilter;
  onClick: () => void;
}): JSX.Element => {
  risk = risk.toLowerCase() as GarmRiskLevelType;
  const { selectedShowDetailsGarmCategory } = useShowDetailsContext();
  const { t } = useTranslation();

  return (
    <ItemContainer
      css={[isSelected && tw`border border-solid shadow-small mb-3 pt-3`]}
      data-testid='garm-overview-list-item'>
      <ItemHeader onClick={onClick} data-testid='garm-overview-list-item-header'>
        <Flex tw='truncate'>
          <LevelIndicator level={risk} tw='mr-2' unrelatedAsCheckmark />
          <Title tw='font-medium'>{t(`insights.garm_category.${category}`)}</Title>
        </Flex>
        {isSelected && <CloseButton>{t('common.deselect')}</CloseButton>}
      </ItemHeader>
      <CollapsibleContainer css={[isSelected ? tw`h-[170px]` : tw`h-0`]}>
        <Spacer direction='vertical' size='xxs' />
        {selectedShowDetailsGarmCategory === category && <GarmOverviewDescription />}
      </CollapsibleContainer>
    </ItemContainer>
  );
};

export { GarmOverviewListItem };
